import React, { useEffect, useState } from 'react';
import './custom.css';
import './themeui.css';
import Main from './components/Main';
import RouteContext from './contexts/RouteContext';
import StopsContext from './contexts/StopsContext';
import CnoPhotoContext from './contexts/CnoPhotoContext';
import AllRouteDataContext from './contexts/AllRouteDataContext';
import FieldActivityContext from './contexts/FieldActivityContext';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import UserContext from './contexts/UserContext';
import { SnackbarProvider } from 'notistack';
import OnlineStatusContext from './contexts/OnlineStatusContext';
import { useInterval, usePersistedState } from './utils/customHooks';
import UnauthenticatedHomeScreen from './components/UnauthenticatedHomeScreen';
import ConnectivityChecker from './utils/connectivityChecker';


const App = () => {

    //state tracking to match the Contexts
    const [containerRoute, setContainerRoute] = usePersistedState("containerRoute", '');
    const [stops, setStops] = usePersistedState("stops", []);
    const [allRoutes, setAllRoutes] = usePersistedState("allRoutes", []);
    const [fieldActivityId, setFieldActivityId] = useState();
    const [cnoPhoto, setCnoPhoto] = useState();
    const [currentUser, setCurrentUser] = useState('');
    const [online, setOnline] = useState(true);

    const { accounts } = useMsal();

    //This is essentially a replacement for the react-detect-offline npm package
    //That package didn't work well with react-router and timely ui updates
    useInterval(() => {

        const statusCheck = async () => {
            const result = await ConnectivityChecker();
            return result;
        };

        statusCheck().then((value) => {
            setOnline(value);
        });
    }, 15000);

    //use effect to update the current user state, only if the accounts array changes, meaning a user was logged in
    useEffect(() => {
        if (accounts.length > 0) {
            setCurrentUser(accounts[0].name);
        }
    }, [accounts]);

    return (
        <React.Fragment>
            <OnlineStatusContext.Provider value={{online, setOnline}}>
                <UserContext.Provider value={{currentUser, setCurrentUser}}>
                    <AllRouteDataContext.Provider value={{allRoutes, setAllRoutes}}>
                        <RouteContext.Provider value={{containerRoute, setContainerRoute}}>
                            <StopsContext.Provider value={{stops, setStops}}>
                                <FieldActivityContext.Provider value={{fieldActivityId, setFieldActivityId}}>
                                    <CnoPhotoContext.Provider value={{cnoPhoto, setCnoPhoto}}>
                                        <AuthenticatedTemplate>
                                            <SnackbarProvider>
                                                <div style={{height:'inherit'}} className="App">
                                                    <Main />
                                                </div>
                                            </SnackbarProvider>
                                        </AuthenticatedTemplate>
                                    </CnoPhotoContext.Provider>
                                </FieldActivityContext.Provider>
                            </StopsContext.Provider>
                        </RouteContext.Provider>
                    </AllRouteDataContext.Provider>
                </UserContext.Provider>
            </OnlineStatusContext.Provider>
            <UnauthenticatedTemplate>
                <UnauthenticatedHomeScreen />
            </UnauthenticatedTemplate>
        </React.Fragment>
    );
};

export default App;